document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".image-slider").forEach(slider => {
        const tabPanel = slider.closest('[role="tabpanel"]')
        const tab = tabPanel ? document.querySelector(`[data-tabs-target="#${tabPanel.id}"]`) : null
        if (!tab) return

        const localizedText = {
            noImages: document.querySelector('meta[name="localized-no-images-available"]')?.getAttribute("content") || "No images available",
            errorLoading: document.querySelector('meta[name="localized-error-loading-images"]')?.getAttribute("content") || "Error loading images"
        }

        /**
         * Renders images inside the slider.
         * @param images - List of image objects { url, id }
         */
        const renderImages = images => {
            if (images.length) {
                slider.innerHTML = `
            <div class="flex gap-4">
                <div class="flex-1">
                    ${createMainImageContainer(images[0])}
                    ${createThumbnails(images)}
                </div>
            </div>
        `
                initializeImageSlider(slider)
            } else {
                slider.innerHTML = `<p>${localizedText.noImages}</p>`
            }
        }

        /**
         * Creates the main image container.
         * @param image - Image object { url, id }
         * @returns {string} - HTML string
         */
        const createMainImageContainer = image => {
            const isVideo = image.url.match(/\.(mp4|webm|ogg)$/i)
            const mediaTag = isVideo
                ? `<video controls class="max-h-[600px] w-auto block" id="mainImage" data-image-id="${image.id}">
                      <source src="${image.url}" type="video/mp4">
                      Your browser does not support the video tag.
                   </video>`
                : `<img src="${image.url}" class="max-h-[600px] w-auto block pointer-events-none transition-transform" id="mainImage" alt="image">`
        
            return `
                <div id="mainImageContainer" class="mb-4 mx-auto px-4 max-w-4xl flex justify-center">
                    <div class="rounded-lg overflow-hidden border border-gray-700 relative" data-image-id="${image.id}">
                        ${mediaTag}
                    </div>
                </div>
            `
        }

        /**
         * Creates thumbnail images.
         * @param images - List of image objects { url, id }
         * @returns {string} - HTML string
         */
        const createThumbnails = images => `
            <div class="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 gap-4">
                ${images.map(image => {
                    const isVideo = image.url.match(/\.(mp4|webm|ogg)$/i)
                    if (isVideo) return

                    return `
                        <div class="thumbnail-container cursor-pointer w-20 h-20 rounded-lg overflow-hidden border border-gray-700 hover:border-gray-500 transition-colors"
                            data-image-url="${image.url}" data-image-id="${image.id}">
                            <img src="${image.url}" class="w-full h-full object-cover thumbnail-image" alt="image">
                        </div>
                    `
                }).join("")}
            </div>
        `

        /**
         * Fetches images from the given URL.
         * @param url - API endpoint to fetch images.
         */
        const fetchImages = async url => {
            try {
                const response = await fetch(url, {headers: {Accept: "application/json"}})
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

                const images = await response.json()
                tab.classList.add("loaded")
                renderImages(images)
            } catch (error) {
                console.error("Error fetching images:", error)
                renderErrorMessage()
            }
        }

        /**
         * Displays an error message when images fail to load.
         */
        const renderErrorMessage = () => {
            slider.innerHTML = `<p>${localizedText.errorLoading}</p>`
        }

        /**
         * Initializes the image slider and handles thumbnail clicks.
         * @param container - The slider container.
         */
        const initializeImageSlider = container => {
            const mainImage = container.querySelector("#mainImage")
            const thumbnails = container.querySelectorAll(".thumbnail-container")

            if (thumbnails.length) thumbnails[0].classList.add("active-thumbnail")

            container.addEventListener("click", event => {
                const thumbnail = event.target.closest(".thumbnail-container")
                if (!thumbnail) return

                thumbnails.forEach(thumb => thumb.classList.remove("active-thumbnail"))
                thumbnail.classList.add("active-thumbnail")

                // Update the main image
                mainImage.src = thumbnail.dataset.imageUrl
                mainImage.dataset.imageId = thumbnail.dataset.imageId
            })
        }

        /**
         * Observes changes to the tab panel and fetches images when it becomes active.
         */
        const observeTabSelection = () => {
            const observer = new MutationObserver(mutations => {
                for (const mutation of mutations) {
                    if (mutation.attributeName === "aria-selected" && tab.getAttribute("aria-selected") === "true" && !tab.classList.contains("loaded")) {
                        const url = slider.dataset.url
                        if (url) fetchImages(url)
                    }
                }
            })

            observer.observe(tab, {attributes: true, attributeFilter: ["aria-selected"]})
        }

        observeTabSelection()
    })
})
